import React, { ReactNode, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './TabView.scss';
import Tabs from '../Tabs/Tabs';
import { noSpaces } from '../../utils/helpers';

export interface ITabViewProps {
  tabs: string[];
  panels: ReactNode[];
  onSelectTab?: (tab: string) => void;
}

const TabView = ({ tabs, panels, onSelectTab }: ITabViewProps) => {
  const [currentTab, setCurrentTab] = useState<string>(tabs[0]);

  const handleSelectTab = (tab: string) => {
    setCurrentTab(tab);
    if (onSelectTab && typeof onSelectTab === 'function') {
      onSelectTab(tab);
    }
  };

  return (
    <section className="tab-view">
      <Tabs
        currentTab={currentTab}
        tabs={tabs}
        onSelectTab={handleSelectTab}
        justify="center"
      />
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          role="tabpanel"
          aria-labelledby={noSpaces(currentTab).toLowerCase()}
          key={noSpaces(currentTab).toLowerCase()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {panels[tabs.indexOf(currentTab)]}
        </motion.div>
      </AnimatePresence>
    </section>
  );
};

export default TabView;
